import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Offcanvas, Nav, Collapse } from "react-bootstrap";
import { useAuth } from "../auth/AuthContext";

// Menús ocultos del backend: "Egresos" queda absorbido por "Gastos Esporádicos";
// "Monedas" solo se administra dentro de Mantenimiento (ver esDeMantenimiento).
const OCULTOS = ["egresos"];
const RUTAS_OCULTAS = ["/monedas"];
// El Administrador no gestiona finanzas personales: solo ve los mantenimientos. Aunque alguien le
// vuelva a dar acceso desde Mantenimiento > Accesos, estas rutas no se le muestran (están protegidas
// por perfil en App.jsx).
const RUTAS_SOLO_CLIENTE = ["/ingresos", "/gastos", "/dashboard", "/cuentas", "/tarjetas-credito"];

function esDeMantenimiento(item) {
  return /mantenimiento/i.test(item.nombre || "") || /\/mant\b/i.test(item.ruta || "");
}

function ItemLink({ item, onNavigate }) {
  return (
    <Nav.Link as={NavLink} to={item.ruta} onClick={onNavigate}
      className={({ isActive }) => "fs-nav-link d-flex align-items-center" + (isActive ? " active" : "")}>
      <i className={`bi ${item.icono || "bi-dot"} fs-nav-icon`}></i>
      <span>{item.nombre}</span>
    </Nav.Link>
  );
}

function ItemsMenu({ onNavigate }) {
  const { menu, esAdministrador } = useAuth();
  const location = useLocation();

  const menuVisible = menu.filter((item) =>
    !OCULTOS.includes((item.nombre || "").trim().toLowerCase()) && !RUTAS_OCULTAS.includes(item.ruta));
  const itemsMant = menuVisible.filter(esDeMantenimiento);
  let itemsPrincipales = menuVisible.filter((item) => !esDeMantenimiento(item));

  const [mantAbierto, setMantAbierto] = useState(location.pathname.toLowerCase().includes("/mant"));

  if (esAdministrador) {
    itemsPrincipales = itemsPrincipales.filter((item) => !RUTAS_SOLO_CLIENTE.includes(item.ruta));
  }

  const listaPrincipal = [...itemsPrincipales];
  if (!esAdministrador) {
    const ingresoItem = { menuId: "ingresos", ruta: "/ingresos", nombre: "Ingresos", icono: "bi-cash-coin" };
    const idxDashboard = listaPrincipal.findIndex((item) => item.ruta === "/dashboard");
    listaPrincipal.splice(idxDashboard >= 0 ? idxDashboard + 1 : 0, 0, ingresoItem);
  }

  return (
    <Nav className="flex-column gap-1">
      {listaPrincipal.map((item) => (
        <ItemLink key={item.menuId} item={item} onNavigate={onNavigate} />
      ))}

      {esAdministrador && (
        <div className="mt-3 pt-3 border-top border-secondary border-opacity-25">
          <button
            type="button"
            onClick={() => setMantAbierto((v) => !v)}
            className="btn btn-link text-decoration-none w-100 d-flex align-items-center justify-content-between px-3 mb-1"
            style={{ color: "#6FBAC2" }}
          >
            <span className="text-uppercase small fw-semibold" style={{ letterSpacing: ".06em" }}>Mantenimiento</span>
            <i className={`bi ${mantAbierto ? "bi-chevron-down" : "bi-chevron-right"} small`}></i>
          </button>
          <Collapse in={mantAbierto}>
            <div>
              <Nav className="flex-column gap-1">
                {itemsMant.map((item) => (
                  <ItemLink key={item.menuId} onNavigate={onNavigate}
                    item={{ ...item, nombre: item.nombre.replace(/^Mantenimiento\s*-\s*/i, "") }} />
                ))}
                {!itemsMant.length && (
                  <div className="px-3 small" style={{ color: "#6FBAC2" }}>Sin submenús configurados.</div>
                )}
              </Nav>
            </div>
          </Collapse>
        </div>
      )}
    </Nav>
  );
}

/** Sidebar fijo en desktop, Offcanvas (menú hamburguesa) en móvil. */
export default function Sidebar({ show, onHide }) {
  return (
    <>
      {/* Desktop: columna fija */}
      <div className="fs-sidebar d-none d-lg-flex flex-column p-3" style={{ width: 260, position: "sticky", top: 0 }}>
        <div className="fs-brand mb-4 px-2">
          <i className="bi bi-graph-up-arrow me-2"></i>FinanzasSys
        </div>
        <ItemsMenu />
      </div>

      {/* Móvil / tablet: Offcanvas */}
      <Offcanvas show={show} onHide={onHide} className="fs-sidebar d-lg-none" style={{ width: 270 }}>
        <Offcanvas.Header closeButton closeVariant="white">
          <Offcanvas.Title className="fs-brand">
            <i className="bi bi-graph-up-arrow me-2"></i>FinanzasSys
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ItemsMenu onNavigate={onHide} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
